export const ROUTES = {
  EMPTY: '/',
  NOT_FOUND: '*',
  FEED: '/home',
  AUTH: '/auth/:token?',
  VIEW: '/post/:postId'
}
